<template>
  <div class="modal-form-container">
    <div ref="modalContent" class="w-full h-full">
      <header class="border-b modal-form-container-header border-line">
        <h1 v-if="!isAdminModal" class="flex items-center modal-form-container-header-title">
          견적 문의하기
        </h1>
        <h1 v-if="isAdminModal" class="flex items-center modal-form-container-header-title">
          견적 생성하기
        </h1>
      </header>

      <div class="text-xs modal-form-container-content md:text-md">
        <div v-if="!isAdminModal" class="mb-10 text-lg leading-4">
          해당 모델 및 견적을 검토 후 입력하신 연락처로 연락드리겠습니다.
        </div>

        <div class="flex itmes-center">
          <span class="flex mt-4 w-32 text-desc">성함</span>
          <div class="w-full">
            <div class="flex w-full cs-form" data-height="md">
              <input
                class=""
                v-model="name"
                @input="validateName"
                type="text"
                placeholder="성함을 입력해주세요."
              />
            </div>
            <div v-if="errMsgName.length" class="cs-feedback cs-feedback-error">
              <i class="fi fi-sr-comment-exclamation"></i><span>{{ errMsgName }}</span>
            </div>
          </div>
        </div>

        <div class="flex mt-3 itmes-center">
          <span class="flex mt-4 w-32 text-desc">소속</span>
          <div class="w-full">
            <div class="flex w-full cs-form" data-height="md">
              <input
                class=""
                v-model="company"
                @input="validateCompany"
                type="text"
                placeholder="소속을 입력해주세요."
              />
            </div>
            <div v-if="errMsgCompany.length" class="cs-feedback cs-feedback-error">
              <i class="fi fi-sr-comment-exclamation"></i><span>{{ errMsgCompany }}</span>
            </div>
          </div>
        </div>

        <div class="flex mt-3 itmes-center">
          <span class="flex mt-4 w-32 text-desc">이메일</span>
          <div class="w-full">
            <div class="flex w-full cs-form" data-height="md">
              <input
                class=""
                v-model="email"
                @input="onValidateEmail"
                type="text"
                placeholder="이메일을 입력해주세요."
              />
            </div>
            <div v-if="errMsgEmail.length" class="cs-feedback cs-feedback-error">
              <i class="fi fi-sr-comment-exclamation"></i><span>{{ errMsgEmail }}</span>
            </div>
          </div>
        </div>

        <div class="flex mt-3 itmes-center">
          <span class="flex mt-4 w-32 text-desc">연락처</span>
          <div class="w-full">
            <div class="flex w-full cs-form" data-height="md">
              <input
                class=""
                v-model="phone"
                @input="validatePhone"
                type="text"
                placeholder="연락처를 입력해주세요."
              />
            </div>
            <div v-if="errMsgPhone.length" class="cs-feedback cs-feedback-error">
              <i class="fi fi-sr-comment-exclamation"></i><span>{{ errMsgPhone }}</span>
            </div>
          </div>
        </div>

        <div v-if="!isAdminModal" class="flex items-center mt-10">
          <input
            class="mr-5 form-check-input"
            id="term"
            type="checkbox"
            :checked="isTerm"
            @change="onCheckTerm"
          />
          <label class="text-lg form-check-label">
            <a class="font-semibold text-second" @click="onTerm">서비스 이용약관</a> 및
            <a class="font-semibold text-second" @click="onPolicy">개인정보</a> 수집 및 처리방침
            동의
          </label>
        </div>
      </div>

      <div class="modal-form-container-footer">
        <loader-button
          ref="next"
          class="w-full cs-pd-btn-xl"
          :cssButton="'cs-btn-clear'"
          @click="onClose"
        >
          <template v-slot:title><span>취소</span></template>
        </loader-button>
        <loader-button
          ref="submitRef"
          class="w-full cs-pd-btn-xl"
          :cssButton="'cs-btn-base'"
          :isDisabled="!isEnableSubmit"
          @click="onSubmit"
        >
          <template v-slot:title><span>확인</span></template>
        </loader-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from "vue";
import LoaderButton from "../../components/LoaderButton.vue";
import {CommonStore} from "../../store/common-store";
import {EstimateStore} from "../../store/estimate-store";
import {ModelStore} from "../../store/model-store";
import {validateEmail} from "../../js/utils";
import {useRoute} from "vue-router";

const route = useRoute();
const submitRef = ref(null);
const isEnableSubmit = ref(false);
const isTerm = ref(false);
const errMsgName = ref("");
const errMsgCompany = ref("");
const errMsgEmail = ref("");
const errMsgPhone = ref("");
const name = ref("성함을 입력해주세요");
const company = ref("하이쓰리디");
const email = ref("prod@hy3d.kr");
const phone = ref("010-1234-5678");

onMounted(() => {
  if (isAdminModal.value) {
    name.value = "관리자";
    company.value = "하이쓰리디";
    email.value = "prod@hy3d.kr";
    phone.value = "070-8015-3367";
    isTerm.value = true;
    isEnableSubmit.value = true;
    submitRef.value.setDisabled(false);
  }
});

const isAdminModal = computed(() => {
  return route.name === "admin-estimates";
});

const validateName = (e) => {
  var pattern1 = /[~!@#$%^&*+|<>?:{}]/;
  errMsgName.value = "";
  if (pattern1.test(e.target.value)) {
    errMsgName.value = "특수문자는 포함할 수 없습니다.";
  } else if (1 >= e.target.value.length) {
    errMsgName.value = "이름은 2자 이상이어야 합니다.";
  }
  validateSubmit();
};

const validateCompany = (e) => {
  errMsgCompany.value = "";
  if (1 >= e.target.value.length || 32 <= e.target.value.length) {
    errMsgCompany.value = "소속은 2자 이상 31자 이하 입니다.";
  }
  validateSubmit();
};

const onValidateEmail = (e) => {
  errMsgEmail.value = validateEmail(e.target.value);
  validateSubmit();
};

const validatePhone = (e) => {
  phone.value = phone.value
    .replace(/[^0-9]/g, "")
    .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3")
    .replace("--", "-");

  let val = e.target.value
    .replace(/[^0-9]/g, "")
    .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3")
    .replace("--", "-");

  let pattern1 = /^01([0|1|2|3|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
  let pattern2 = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/;
  errMsgPhone.value = "";
  let result1 = !pattern1.test(val) && !pattern2.test(val);
  let result2 = 1 > val.length && 13 < val.length;

  if (result1 || result2) {
    errMsgPhone.value = "전화번호 양식과 다릅니다.";
  }
  validateSubmit();
};

const validateSubmit = () => {
  if (isTerm.value) {
    if (
      !errMsgName.value.length &&
      !errMsgCompany.value.length &&
      !errMsgEmail.value.length &&
      !errMsgPhone.value.length
    ) {
      if (name.value.length && company.value.length && email.value.length && phone.value.length) {
        isEnableSubmit.value = true;
        submitRef.value.setDisabled(false);
        return;
      }
    }
  }

  isEnableSubmit.value = false;
  submitRef.value.setDisabled(true);
};

const onCheckTerm = () => {
  isTerm.value = !isTerm.value;
  validateSubmit();
};

const onTerm = () => {
  CommonStore().showTermModal();
};
const onPolicy = () => {
  CommonStore().showPolicyModal();
};

const onClose = () => {
  CommonStore().closeModal();
};

const onSubmit = () => {
  const estimateStore = EstimateStore();
  const modelStore = ModelStore();

  if (isAdminModal.value) {
    const values = {
      id: 0,
      models: [],
      discountCost: 0,
      client: {
        name: name.value,
        company: company.value,
        email: email.value,
        phone: phone.value,
      },
    };
    estimateStore.reqCreateEstimate(values);
  } else {
    const values = {
      id: estimateStore.estimate.id,
      models: modelStore.models,
      discountCost: estimateStore.estimate.discountCost,
      client: {
        name: name.value,
        company: company.value,
        email: email.value,
        phone: phone.value,
      },
    };
    estimateStore.reqSubmit(values);
  }
};
</script>
